import type { FC } from "react";
import React from "react";
import { Navigate } from "react-router-dom";

import { hasValue } from "@core/foundation/types";

import { ErrorView, LoadingView } from "@react/foundation/placeholder";

import { router } from "../../../bootstrap/router.ts";
import { useAppNavigation } from "../../../shared/hooks/useAppNavigation.ts";
import {
  connectOnReturnSelectors,
  useConnectOnReturnStore,
} from "../state/connect-on-return.ts";

export const ConnectionsCallbackView: FC = () => {
  const error = useConnectOnReturnStore(connectOnReturnSelectors.error);

  const isPending = useConnectOnReturnStore(connectOnReturnSelectors.isPending);

  const { goToGithubConnections } = useAppNavigation();

  if (isPending) {
    return <LoadingView />;
  }

  if (hasValue(error)) {
    return (
      <ErrorView
        actionLabel="Go to GitHub connections"
        description={error}
        onAction={goToGithubConnections}
      />
    );
  }

  return <Navigate replace to={router.getUrl("GithubConnections")} />;
};
